import {PATH_REPORT_RECEIVED, PATH_REPORTS} from "@constants/navigate";
import {IBreadcrumbItem} from "@ui/breadcrumbCustom/types";

export const BREADCRUMBS_REPORT_BUILDER:IBreadcrumbItem[] = [
    {
        label: 'reportLabels.reports', path: PATH_REPORTS
    },
    {
        label: 'reportLabels.reportBuilder', path: PATH_REPORT_RECEIVED
    },
]